module.exports = __webpack_public_path__ + "static/media/couches-14.14ec1d4f.jpg";